import {
  Briefcase,
  CurrencyInr,
  HourglassHigh,
  User,
  Warning,
} from "@phosphor-icons/react"
import { Modal } from "@vesatogo/grass-core"
import { inr } from "@vesatogo/utils"
import Deviation from "~/assets/deviation.svg"
import { getOrdinalString } from "~/utils/ordinalString"

type OverdueModalConfirmationProps = {
  isOpen: boolean
  setOpen: any
  onConfirm?: () => void
  onCancel?: () => void
  data?: {
    tradeId?: any
    buyerName?: string
    availableAmount?: number
    tradeAmount?: number
    overdueCount?: number
    overdueAmount?: number
  }
}
export const OverdueModalConfirmation = ({
  isOpen,
  setOpen,
  onConfirm,
  onCancel,
  data,
}: OverdueModalConfirmationProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      title={"Overdue Approval Confirmation"}
      primaryActionButtonProps={{
        text: "Continue with Overdue Approval",
        onClick: async () => {
          onConfirm?.()
        },
      }}
      secondaryActionButtonProps={{
        text: "Close without saving",
        intent: "danger",
        onClick: () => {
          onCancel?.()
        },
      }}
    >
      <div>
        <img
          alt="biz logo"
          width={250}
          height={250}
          src={Deviation}
          className="m-auto pb-5"
        />
        <div className="border-1 border-gray-300 mt-5 rounded-lg">
          <div className="text-green font-600 bg-gray-100 rounded-lg p-2  flex gap-2 items-center">
            <Warning className="text-yellow" size={20} weight="fill" />
            Existing Overdue ({getOrdinalString(data?.overdueCount || 0) + " "}
            Overdue Request)
          </div>
          <div className="p-2 text-gray-800 flex flex-col gap-2">
            <div className="flex gap-1 items-center">
              <User className="text-green-400" size={20} weight="fill" /> Buyer
              Name: {data?.buyerName}
            </div>
            <div className="flex gap-1 items-center">
              <CurrencyInr className="text-green-300" size={20} weight="fill" />
              Available Limit: {inr(data?.availableAmount || 0)}
            </div>
            <div className="flex gap-1 items-center">
              <Briefcase className="text-brown" size={20} weight="fill" />
              Current Transaction Amount: {inr(data?.tradeAmount || 0)}
            </div>
            <div className="flex gap-1 items-center">
              <HourglassHigh className="text-cyan" size={20} weight="fill" />
              Overdue Amount: {inr(data?.overdueAmount || 0)}
            </div>
          </div>
        </div>
        <div className="my-3 font-600">
          Do you want to continue with overdue approval or cancel this trade?
        </div>
      </div>
    </Modal>
  )
}
